import { render, staticRenderFns } from "./IconCloudUploadSolid.vue?vue&type=template&id=58e5e08c"
import script from "./IconCloudUploadSolid.vue?vue&type=script&lang=js"
export * from "./IconCloudUploadSolid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports